import { render } from "./HeroSection.vue?vue&type=template&id=42540885&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=42540885&lang=scss&scoped=true"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42540885"]])

export default __exports__